import React from 'react';
import { FormFeedback, FormGroup, Input } from 'reactstrap';

const CustomValidationInput = props => {
  const {
    disabled,
    placeholder,
    value,
    name,
    onChange,
    validStatus,
    messageText,
    messageStatus,
    onFocus,
    onBlur,
    shorter,
  } = props;
  return (
    <FormGroup className={shorter ? "register-input" : "validation-input"}>
      <Input
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        type="text"
        name={name}
        onChange={onChange}
        className="input-forward"
        invalid={messageStatus && !validStatus}
        valid={messageStatus && validStatus}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {messageStatus && (
        <FormFeedback valid={validStatus} invalid={!validStatus}>
          {messageText}
        </FormFeedback>
      )}
    </FormGroup>
  );
};

export default CustomValidationInput;
